export default {
  name: 'RateChangeModal'
};